import React from 'react';

import './ProductNotFound.css';

class ProductNotFound extends React.Component{

    constructor() {
        super();

        this.state = {
            width: document.documentElement.clientWidth,
            count: 0,
            recReasonExpanded: false,
            descriptionExpanded: false,
            addedToCart: false,
            showProductDescription: false,
            showWhyIsItGood: true
        };

    }


    render() {
        return (
            <div className="product product-not-found" >
                <div className="not-found-image">
                    <img alt="Not found" src="/images/product/sorry-button.svg" />
                </div>
                <div className="not-found-message">
                    We don’t have any products that meet your criteria.
                    Please adjust your requirements in your Skin Profile page or contact skin advisor via text. 
                </div>
            </div>
        );

    }
}

export default ProductNotFound;



// WEBPACK FOOTER //
// ./src/components/product/ProductNotFound.js